import { mapService } from '../services'

const state = {
  actions: [],
  informations: [],
  events: [],
  loadEnd: true,
  fromSse: false
}

const getters = {
  getActions (state) {
    return state.actions
  },
  getInformations (state) {
    return state.informations
  },
  getEvents (state) {
    return state.events
  },
  getLoadEnd (state) {
    return state.loadEnd
  },
  getFromSse (state) {
    return state.fromSse
  }
}

const mutations = {
  getAllActions (state, { items }) {
    state.actions = items
  },
  getAllInformations (state, { items }) {
    state.informations = items
  },
  getAllEvents (state, { items }) {
    state.events = items
  },
  setLoadEnd (state, value) {
    state.loadEnd = value
  },
  setFromSse (state, value) {
    state.fromSse = value
  }
}

const actions = {
  findAllActions (context, fromSse) {
    const filters = context.rootGetters['filters/getFilters']
    return mapService.findAllActions(filters)
      .then(response => {
        context.commit('getAllActions', { items: response.data })
        context.commit('setFromSse', fromSse)
        return response
      })
  },
  findAllInformations (context, fromSse) {
    const filters = context.rootGetters['filters/getFilters']
    return mapService.findAllInformations(filters)
      .then(response => {
        context.commit('getAllInformations', { items: response.data })
        context.commit('setFromSse', fromSse)
        return response
      })
  },
  findAllEvents (context, fromSse) {
    const filters = context.rootGetters['filters/getFilters']
    return mapService.findAllEvents(filters)
      .then(response => {
        context.commit('getAllEvents', { items: response.data })
        context.commit('setFromSse', fromSse)
        return response
      })
  },
  setLoadEnd (context, value) {
    context.commit('setLoadEnd', value)
  },
  setFromSse (context, value) {
    context.commit('setFromSse', value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
